var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    x: 0.75,
    y: 0.75,
    stroke: "#9595A7",
    strokeDasharray: "3 3",
    strokeWidth: 1.5,
    rx: 3.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9595A7",
    d: "M3 5a2 2 0 0 1 2-2h1v6H5a2 2 0 0 1-2-2z"
  })));
};
export default SvgPending;